import NextLink from 'next/link';
import { FC } from 'react';
import { useIsMobile } from '@raysee/hooks';

type Props = Parameters<typeof NextLink>[0];

export const Link: FC<Props> = ({ children, href, prefetch, ...props }) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    const query =
      typeof href === 'string'
        ? ''
        : Object.entries(href.query ?? {}).reduce((acc, [key, value]) => {
            if (!value || key === 'is_mobile') return acc;
            return `${acc}&${key}=${value}`;
          }, 'is_mobile=1');
    const url =
      typeof href === 'string' ? href : query ? `${href.pathname}?${query}` : href.pathname ?? '/';

    return (
      <a href={url} {...props}>
        {children}
      </a>
    );
  } else {
    return (
      <NextLink href={href} prefetch={prefetch ?? !isMobile} {...props}>
        {children}
      </NextLink>
    );
  }
};
